import React from 'react';
import Icon from '../../../components/AppIcon';

const ReferralInfoSection = ({ formData, errors, onChange }) => {
  const referralTypes = [
    { 
      value: 'Cesspool Conversion', 
      label: 'Cesspool Conversion', 
      description: 'Converting cesspool systems to compliant septic systems',
      icon: 'RefreshCw'
    },
    { 
      value: 'Septic Maintenance', 
      label: 'Septic Maintenance', 
      description: 'Regular maintenance and servicing of septic systems',
      icon: 'Settings'
    },
    { 
      value: 'Other', 
      label: 'Other', 
      description: 'Other septic or wastewater-related services',
      icon: 'MoreHorizontal'
    }
  ];

  return (
    <div className="bg-card rounded-lg border border-border elevation-1 overflow-hidden">
      <div className="p-6 border-b border-border bg-muted/30">
        <h2 className="text-xl font-semibold text-foreground flex items-center gap-2">
          <Icon name="Tag" size={20} />
          Referral Information
        </h2>
        <p className="text-sm text-muted-foreground mt-1">
          Select the type of referral and add any additional notes
        </p>
      </div>
      <div className="p-6">
        <div className="mb-6">
          <label className="block text-sm font-medium text-foreground mb-3">
            Referral Type <span className="text-error">*</span>
          </label>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {referralTypes?.map((type) => (
              <label
                key={type?.value}
                className={`flex items-start gap-3 p-4 rounded-lg border-2 cursor-pointer transition-all duration-200 ${
                  formData?.referralType === type?.value
                    ? 'border-primary bg-primary/5' :'border-border bg-background hover:border-primary/50 hover:bg-muted/30'
                }`}
              >
                <input
                  type="radio"
                  name="referralType"
                  value={type?.value}
                  checked={formData?.referralType === type?.value}
                  onChange={onChange}
                  className="mt-1 w-4 h-4 text-primary border-border focus:ring-2 focus:ring-primary focus:ring-offset-2"
                />
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <Icon name={type?.icon} size={18} color={formData?.referralType === type?.value ? 'var(--color-primary)' : 'var(--color-muted-foreground)'} />
                    <span className={`font-medium ${formData?.referralType === type?.value ? 'text-primary' : 'text-foreground'}`}>
                      {type?.label}
                    </span>
                  </div>
                  <p className="text-sm text-muted-foreground">{type?.description}</p>
                </div>
              </label>
            ))}
          </div>
          {errors?.referralType && (
            <p className="text-sm text-error mt-2 flex items-center gap-1">
              <Icon name="AlertCircle" size={14} />
              {errors?.referralType}
            </p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Additional Notes
          </label>
          <textarea
            name="notes"
            value={formData?.notes}
            onChange={onChange}
            placeholder="Add any additional information about this lead, customer preferences, timeline, or special requirements..."
            rows={5}
            className="w-full px-3 py-2 border border-input rounded-md bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent transition-all duration-200 resize-none"
          />
          <p className="text-xs text-muted-foreground mt-1">
            Optional - Provide context that will help with lead qualification
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReferralInfoSection;